// Team RELEASE — i18n keys (prefix `rel.`). Auto-merged by i18n/extensions/index.js.
const en = {
  // Autosave / drafts
  "rel.autosave.unsaved": "Unsaved changes",
  "rel.autosave.error": "Couldn't save",
  "rel.autosave.savedAt": "Saved {time}",
  "rel.autosave.idle": "Changes are saved automatically",
  "rel.drafts.title": "My drafts",
  "rel.drafts.empty": "No draft releases yet",
  "rel.drafts.emptyDesc": "Drafts are saved automatically while you fill in the wizard.",
  "rel.drafts.close": "Close",
  "rel.drafts.lastSaved": "Saved {date}",
  "rel.drafts.resumed": "Draft restored — continue where you left off",
  "rel.drafts.saved": "Draft saved",
  "rel.drafts.saveFailed": "Draft could not be saved",
  "rel.drafts.needsMore": "Add a title or upload a file before saving a draft",
  "rel.drafts.needsEdits": "Needs edits",

  // Wizard copy
  "rel.wizard.confirmRequired": "Please confirm all required items to continue.",
  "rel.wizard.fillRequired": "Fill in all required fields to enable submission",
  "rel.wizard.untitledTrack": "Untitled Track",
  "rel.wizard.previous": "Previous",
  "rel.wizard.albumSubmitted": "Album submitted successfully!",
  "rel.wizard.albumSubmitFailed": "Failed to submit album",
  "rel.wizard.split.title": "Revenue Split",
  "rel.wizard.split.desc": "Share revenue with collaborators (songwriters, producers, featured artists)",
  "rel.wizard.split.yourShare": "Your share:",
  "rel.wizard.split.edit": "Edit Contributors ({n})",
  "rel.wizard.split.add": "Add Revenue Split Contributors",
  "rel.wizard.split.explanation": "Contributors will receive email invitations to accept their share. Revenue will be distributed automatically once they accept.",

  // Store preview
  "rel.preview.title": "Store preview",
  "rel.preview.subtitle": "Live preview as you type",
  "rel.preview.open": "Preview",
  "rel.preview.close": "Close preview",
  "rel.preview.single": "Single",
  "rel.preview.album": "Album",
  "rel.preview.ep": "EP",
  "rel.preview.untitled": "Untitled release",
  "rel.preview.untitledTrack": "Untitled track",
  "rel.preview.artistPlaceholder": "Artist name",
  "rel.preview.songs": "{n} songs",
  "rel.preview.song": "1 song",
  "rel.preview.dateTbd": "Release date not set",
  "rel.preview.disclaimer": "Stylized preview — the final look is decided by each store.",
  "rel.preview.noCover": "No cover yet",
  "rel.preview.play": "Play",
  "rel.preview.save": "Save",
  "rel.preview.more": "More",

  // Quality check
  "rel.qc.title": "Quality check",
  "rel.qc.score": "Release quality {score}%",
  "rel.qc.subtitle": "We check your release against store guidelines before you submit.",
  "rel.qc.refresh": "Re-check",
  "rel.qc.fix": "Fix",
  "rel.qc.summary": "{p} passed · {w} warnings · {f} issues",
  "rel.qc.nonBlocking": "Warnings don't block submission, but fixing them reduces the chance of store rejections.",
  "rel.qc.grade.great": "Ready for stores",
  "rel.qc.grade.good": "Almost there",
  "rel.qc.grade.poor": "Needs attention",
  "rel.qc.group.artwork": "Artwork",
  "rel.qc.group.audio": "Audio",
  "rel.qc.group.metadata": "Metadata",
  "rel.qc.group.schedule": "Schedule",
  "rel.qc.cover.missing": "Cover art is missing",
  "rel.qc.cover.checking": "Checking cover art…",
  "rel.qc.cover.ok": "Cover art {w}×{h} {fmt}",
  "rel.qc.cover.small": "Cover is {w}×{h}px — stores require at least 3000×3000px",
  "rel.qc.cover.notSquare": "Cover must be square (currently {w}×{h}px)",
  "rel.qc.cover.format": "Cover format {fmt} — use JPG or PNG",
  "rel.qc.cover.unreadable": "Cover art could not be read",
  "rel.qc.audio.missing": "Audio missing for “{track}”",
  "rel.qc.audio.format": "“{track}”: {fmt} — upload WAV or FLAC",
  "rel.qc.audio.sampleRate": "“{track}”: {sr} kHz — use 44.1 kHz or higher",
  "rel.qc.audio.bitDepth": "“{track}”: {bd}-bit — 16 or 24-bit recommended",
  "rel.qc.audio.short": "“{track}” is very short ({dur}) — some stores require 30s+",
  "rel.qc.audio.long": "“{track}” is very long ({dur}) — double-check the file",
  "rel.qc.audio.ok": "“{track}”: {details}",
  "rel.qc.audio.pending": "“{track}”: {fmt} uploaded — technical details appear after the draft is saved",
  "rel.qc.title.missing": "Title is missing",
  "rel.qc.title.allCaps": "Avoid ALL CAPS in “{title}”",
  "rel.qc.title.emoji": "Remove emojis from “{title}”",
  "rel.qc.title.feat": "Don't put “feat.” in “{title}” — use the featured artists field",
  "rel.qc.title.casing": "Check the capitalization of “{title}”",
  "rel.qc.title.spaces": "Remove extra spaces from “{title}”",
  "rel.qc.title.ok": "Title formatting looks good",
  "rel.qc.artist.missing": "Add a primary artist",
  "rel.qc.artist.ok": "Primary artist set",
  "rel.qc.explicit.missing": "Explicit content flag not set{track}",
  "rel.qc.explicit.ok": "Explicit content flag set",
  "rel.qc.genre.missing": "Select a primary genre",
  "rel.qc.genre.ok": "Genre set",
  "rel.qc.credits.missing": "Add at least one songwriter/composer credit{track}",
  "rel.qc.credits.ok": "Songwriter credits added",
  "rel.qc.isrc.invalid": "Invalid ISRC “{isrc}” (expected CC-XXX-YY-NNNNN)",
  "rel.qc.isrc.ok": "ISRC format valid",
  "rel.qc.date.missing": "Pick a release date",
  "rel.qc.date.past": "Release date is in the past",
  "rel.qc.date.soon": "Release is in {n} days — 14+ days is recommended for playlist pitching",
  "rel.qc.date.ok": "Release date {date} ({n} days away)",
  "rel.qc.label.missing": "No label / © line — your artist name will be used",
  "rel.qc.label.ok": "Label / © line set",

  // Submit success
  "rel.success.title": "Your release is on its way!",
  "rel.success.subtitle": "“{title}” was submitted for review.",
  "rel.success.reviewTime": "Review time",
  "rel.success.reviewTimeValue": "1–3 business days",
  "rel.success.expectedLive": "Expected live date",
  "rel.success.dateTbd": "Not set",
  "rel.success.next": "Next steps",
  "rel.success.smartLink": "Create Smart Link",
  "rel.success.smartLinkDesc": "One link to every store — perfect for your bio.",
  "rel.success.preSave": "Start Pre-Save campaign",
  "rel.success.preSaveDesc": "Collect saves before release day to boost the algorithm.",
  "rel.success.view": "View release",
  "rel.success.viewDesc": "Track its review status and details.",
  "rel.success.dashboard": "Back to dashboard",
  "rel.success.dashboardDesc": "See your stats and earnings.",

  // Status
  "rel.status.draft": "Draft",
  "rel.status.submitted": "Submitted",
  "rel.status.in_review": "In review",
  "rel.status.needs_edits": "Needs edits",
  "rel.status.approved": "Approved",
  "rel.status.scheduled": "Scheduled",
  "rel.status.live": "Live",
  "rel.status.rejected": "Rejected",
  "rel.status.taken_down": "Taken down",

  // Releases list
  "rel.list.title": "My releases",
  "rel.list.subtitle": "Manage all your releases and follow their status.",
  "rel.list.new": "New release",
  "rel.list.search": "Search releases…",
  "rel.list.filter": "Status",
  "rel.list.all": "All",
  "rel.list.sort": "Sort",
  "rel.list.sort.newest": "Newest",
  "rel.list.sort.oldest": "Oldest",
  "rel.list.sort.releaseDate": "Release date",
  "rel.list.sort.az": "Name (A–Z)",
  "rel.list.sort.za": "Name (Z–A)",
  "rel.list.view.grid": "Grid view",
  "rel.list.view.list": "List view",
  "rel.list.view.kanban": "Board view",
  "rel.list.viewAction": "View",
  "rel.list.edit": "Edit",
  "rel.list.fixNow": "Fix now",
  "rel.list.delete": "Delete",
  "rel.list.cancel": "Cancel",
  "rel.list.actions": "Actions",
  "rel.list.unknownArtist": "Unknown artist",
  "rel.list.untitled": "Untitled release",
  "rel.list.empty": "Empty",
  "rel.list.emptyTitle": "No releases yet",
  "rel.list.emptyDesc": "Create your first release and get it on Spotify, Apple Music and 150+ stores.",
  "rel.list.noResultsTitle": "No releases match your filters",
  "rel.list.noResultsDesc": "Try a different search term or status filter.",
  "rel.list.clearFilters": "Clear filters",
  "rel.list.adminNote": "Note from our team",
  "rel.list.releaseDate": "Release date",
  "rel.list.created": "Created",
  "rel.list.inDays": "in {n} days",
  "rel.list.today": "Today",
  "rel.list.tomorrow": "Tomorrow",
  "rel.list.tracks": "{n} tracks",
  "rel.list.col.release": "Release",
  "rel.list.col.artist": "Artist",
  "rel.list.col.tracks": "Tracks",
  "rel.list.col.status": "Status",
  "rel.list.col.date": "Release date",
  "rel.list.deleteTitle": "Delete release",
  "rel.list.deleteConfirm": "Delete “{name}”?",
  "rel.list.cannotUndo": "This action cannot be undone.",
  "rel.list.deleteSuccess": "Release deleted",
  "rel.list.deleteFailed": "Delete failed",
  "rel.list.fetchFailed": "Couldn't load your releases",
  "rel.list.count": "{n} releases",

  // Release detail
  "rel.detail.back": "Back to releases",
  "rel.detail.loadFailed": "Couldn't load this release",
  "rel.detail.timeline": "Status timeline",
  "rel.detail.step.created": "Created",
  "rel.detail.step.submitted": "Submitted",
  "rel.detail.step.reviewed": "Reviewed",
  "rel.detail.step.live": "Live",
  "rel.detail.pending": "Pending",
  "rel.detail.feedbackEdits": "Changes requested by our team",
  "rel.detail.feedbackRejected": "Your release was rejected",
  "rel.detail.feedbackTakenDown": "Your release was taken down",
  "rel.detail.fixNow": "Fix now",
  "rel.detail.tracks": "Tracks",
  "rel.detail.noTracks": "No tracks added yet",
  "rel.detail.play": "Play preview",
  "rel.detail.pause": "Pause",
  "rel.detail.noAudio": "No audio",
  "rel.detail.quickActions": "Quick actions",
  "rel.detail.smartLink": "Smart Link",
  "rel.detail.preSave": "Pre-Save",
  "rel.detail.edit": "Edit",
  "rel.detail.listenOn": "Listen on",
  "rel.detail.info": "Release info",
  "rel.detail.releaseDate": "Release date",
  "rel.detail.genre": "Genre",
  "rel.detail.subGenre": "Sub-genre",
  "rel.detail.type": "Type",
  "rel.detail.label": "Label",
  "rel.detail.version": "Version",
  "rel.detail.language": "Language",
  "rel.detail.publisher": "Publisher",
  "rel.detail.stores": "Stores ({n})",
  "rel.detail.explicit": "Explicit",
  "rel.detail.instrumental": "Instrumental",
  "rel.detail.history": "History",
  "rel.detail.songwriters": "Songwriters",
  "rel.detail.featuring": "feat.",
  "rel.detail.lyrics": "Lyrics",
  "rel.detail.takedownRequested": "Takedown requested",
  "rel.detail.liveIn": "Goes live in {n} days",
  "rel.detail.liveToday": "Goes live today",
  "rel.edit.notEditable": "This release can no longer be edited. Only drafts and releases with requested changes can be modified.",
};

const tr = {
  "rel.autosave.unsaved": "Kaydedilmemiş değişiklikler",
  "rel.autosave.error": "Kaydedilemedi",
  "rel.autosave.savedAt": "{time} kaydedildi",
  "rel.autosave.idle": "Değişiklikler otomatik kaydedilir",
  "rel.drafts.title": "Taslaklarım",
  "rel.drafts.empty": "Henüz taslak yayın bulunmuyor",
  "rel.drafts.emptyDesc": "Sihirbazı doldururken taslaklarınız otomatik kaydedilir.",
  "rel.drafts.close": "Kapat",
  "rel.drafts.lastSaved": "{date} kaydedildi",
  "rel.drafts.resumed": "Taslak geri yüklendi — kaldığınız yerden devam edin",
  "rel.drafts.saved": "Taslak kaydedildi",
  "rel.drafts.saveFailed": "Taslak kaydedilemedi",
  "rel.drafts.needsMore": "Taslak kaydetmek için bir başlık girin veya dosya yükleyin",
  "rel.drafts.needsEdits": "Düzenleme gerekli",

  "rel.wizard.confirmRequired": "Devam etmek için lütfen tüm zorunlu onayları işaretleyin.",
  "rel.wizard.fillRequired": "Gönderimi etkinleştirmek için tüm gerekli alanları doldurun",
  "rel.wizard.untitledTrack": "İsimsiz Parça",
  "rel.wizard.previous": "Önceki",
  "rel.wizard.albumSubmitted": "Albüm başarıyla gönderildi!",
  "rel.wizard.albumSubmitFailed": "Albüm gönderilemedi",
  "rel.wizard.split.title": "Gelir Paylaşımı",
  "rel.wizard.split.desc": "Geliri iş birlikçilerinizle paylaşın (söz yazarları, prodüktörler, konuk sanatçılar)",
  "rel.wizard.split.yourShare": "Sizin payınız:",
  "rel.wizard.split.edit": "Katkıda Bulunanları Düzenle ({n})",
  "rel.wizard.split.add": "Gelir Paylaşımı Katılımcısı Ekle",
  "rel.wizard.split.explanation": "Katkıda bulunanlar paylarını kabul etmeleri için e-posta daveti alır. Kabul ettiklerinde gelir otomatik olarak dağıtılır.",

  "rel.preview.title": "Mağaza önizlemesi",
  "rel.preview.subtitle": "Yazdıkça canlı önizleme",
  "rel.preview.open": "Önizleme",
  "rel.preview.close": "Önizlemeyi kapat",
  "rel.preview.single": "Single",
  "rel.preview.album": "Albüm",
  "rel.preview.ep": "EP",
  "rel.preview.untitled": "İsimsiz yayın",
  "rel.preview.untitledTrack": "İsimsiz parça",
  "rel.preview.artistPlaceholder": "Sanatçı adı",
  "rel.preview.songs": "{n} şarkı",
  "rel.preview.song": "1 şarkı",
  "rel.preview.dateTbd": "Yayın tarihi belirlenmedi",
  "rel.preview.disclaimer": "Stilize önizleme — nihai görünümü her mağaza kendisi belirler.",
  "rel.preview.noCover": "Henüz kapak yok",
  "rel.preview.play": "Oynat",
  "rel.preview.save": "Kaydet",
  "rel.preview.more": "Daha fazla",

  "rel.qc.title": "Kalite kontrolü",
  "rel.qc.score": "Yayın kalitesi %{score}",
  "rel.qc.subtitle": "Göndermeden önce yayınınızı mağaza kurallarına göre kontrol ediyoruz.",
  "rel.qc.refresh": "Yeniden kontrol et",
  "rel.qc.fix": "Düzelt",
  "rel.qc.summary": "{p} başarılı · {w} uyarı · {f} sorun",
  "rel.qc.nonBlocking": "Uyarılar gönderimi engellemez, ancak düzeltmek mağaza reddi riskini azaltır.",
  "rel.qc.grade.great": "Mağazalara hazır",
  "rel.qc.grade.good": "Neredeyse hazır",
  "rel.qc.grade.poor": "İlgilenmeniz gerekiyor",
  "rel.qc.group.artwork": "Kapak",
  "rel.qc.group.audio": "Ses",
  "rel.qc.group.metadata": "Meta veri",
  "rel.qc.group.schedule": "Takvim",
  "rel.qc.cover.missing": "Kapak görseli eksik",
  "rel.qc.cover.checking": "Kapak görseli kontrol ediliyor…",
  "rel.qc.cover.ok": "Kapak {w}×{h} {fmt}",
  "rel.qc.cover.small": "Kapak {w}×{h}px — mağazalar en az 3000×3000px ister",
  "rel.qc.cover.notSquare": "Kapak kare olmalı (şu an {w}×{h}px)",
  "rel.qc.cover.format": "Kapak formatı {fmt} — JPG veya PNG kullanın",
  "rel.qc.cover.unreadable": "Kapak görseli okunamadı",
  "rel.qc.audio.missing": "“{track}” için ses dosyası eksik",
  "rel.qc.audio.format": "“{track}”: {fmt} — WAV veya FLAC yükleyin",
  "rel.qc.audio.sampleRate": "“{track}”: {sr} kHz — 44.1 kHz veya üzeri kullanın",
  "rel.qc.audio.bitDepth": "“{track}”: {bd}-bit — 16 veya 24-bit önerilir",
  "rel.qc.audio.short": "“{track}” çok kısa ({dur}) — bazı mağazalar 30 sn+ ister",
  "rel.qc.audio.long": "“{track}” çok uzun ({dur}) — dosyayı kontrol edin",
  "rel.qc.audio.ok": "“{track}”: {details}",
  "rel.qc.audio.pending": "“{track}”: {fmt} yüklendi — teknik detaylar taslak kaydedilince görünür",
  "rel.qc.title.missing": "Başlık eksik",
  "rel.qc.title.allCaps": "“{title}” başlığında TAMAMI BÜYÜK HARF kullanmayın",
  "rel.qc.title.emoji": "“{title}” başlığından emojileri kaldırın",
  "rel.qc.title.feat": "“{title}” başlığına “feat.” yazmayın — konuk sanatçı alanını kullanın",
  "rel.qc.title.casing": "“{title}” başlığının büyük/küçük harf kullanımını kontrol edin",
  "rel.qc.title.spaces": "“{title}” başlığındaki fazla boşlukları kaldırın",
  "rel.qc.title.ok": "Başlık biçimi uygun",
  "rel.qc.artist.missing": "Ana sanatçı ekleyin",
  "rel.qc.artist.ok": "Ana sanatçı belirlendi",
  "rel.qc.explicit.missing": "Müstehcen içerik işareti seçilmedi{track}",
  "rel.qc.explicit.ok": "Müstehcen içerik işareti seçildi",
  "rel.qc.genre.missing": "Ana tür seçin",
  "rel.qc.genre.ok": "Tür seçildi",
  "rel.qc.credits.missing": "En az bir söz yazarı/besteci kredisi ekleyin{track}",
  "rel.qc.credits.ok": "Söz yazarı kredileri eklendi",
  "rel.qc.isrc.invalid": "Geçersiz ISRC “{isrc}” (beklenen: CC-XXX-YY-NNNNN)",
  "rel.qc.isrc.ok": "ISRC formatı geçerli",
  "rel.qc.date.missing": "Bir yayın tarihi seçin",
  "rel.qc.date.past": "Yayın tarihi geçmişte",
  "rel.qc.date.soon": "Yayına {n} gün var — playlist pitching için 14+ gün önerilir",
  "rel.qc.date.ok": "Yayın tarihi {date} ({n} gün sonra)",
  "rel.qc.label.missing": "Plak şirketi / © satırı yok — sanatçı adınız kullanılacak",
  "rel.qc.label.ok": "Plak şirketi / © satırı belirlendi",

  "rel.success.title": "Yayınınız yola çıktı!",
  "rel.success.subtitle": "“{title}” incelemeye gönderildi.",
  "rel.success.reviewTime": "İnceleme süresi",
  "rel.success.reviewTimeValue": "1–3 iş günü",
  "rel.success.expectedLive": "Beklenen yayın tarihi",
  "rel.success.dateTbd": "Belirlenmedi",
  "rel.success.next": "Sonraki adımlar",
  "rel.success.smartLink": "Smart Link oluştur",
  "rel.success.smartLinkDesc": "Tüm mağazalar için tek link — biyografiniz için ideal.",
  "rel.success.preSave": "Pre-Save kampanyası başlat",
  "rel.success.preSaveDesc": "Yayın gününden önce kayıt toplayarak algoritmayı güçlendirin.",
  "rel.success.view": "Yayını görüntüle",
  "rel.success.viewDesc": "İnceleme durumunu ve detayları takip edin.",
  "rel.success.dashboard": "Panele dön",
  "rel.success.dashboardDesc": "İstatistiklerinizi ve kazançlarınızı görün.",

  "rel.status.draft": "Taslak",
  "rel.status.submitted": "Gönderildi",
  "rel.status.in_review": "İncelemede",
  "rel.status.needs_edits": "Düzenleme gerekli",
  "rel.status.approved": "Onaylandı",
  "rel.status.scheduled": "Planlandı",
  "rel.status.live": "Yayında",
  "rel.status.rejected": "Reddedildi",
  "rel.status.taken_down": "Kaldırıldı",

  "rel.list.title": "Yayınlarım",
  "rel.list.subtitle": "Tüm yayınlarınızı buradan yönetin ve durumlarını takip edin.",
  "rel.list.new": "Yeni yayın",
  "rel.list.search": "Yayınlarda ara…",
  "rel.list.filter": "Durum",
  "rel.list.all": "Tümü",
  "rel.list.sort": "Sırala",
  "rel.list.sort.newest": "En yeni",
  "rel.list.sort.oldest": "En eski",
  "rel.list.sort.releaseDate": "Yayın tarihi",
  "rel.list.sort.az": "İsim (A–Z)",
  "rel.list.sort.za": "İsim (Z–A)",
  "rel.list.view.grid": "Izgara görünümü",
  "rel.list.view.list": "Liste görünümü",
  "rel.list.view.kanban": "Pano görünümü",
  "rel.list.viewAction": "Görüntüle",
  "rel.list.edit": "Düzenle",
  "rel.list.fixNow": "Şimdi düzelt",
  "rel.list.delete": "Sil",
  "rel.list.cancel": "İptal",
  "rel.list.actions": "İşlemler",
  "rel.list.unknownArtist": "Bilinmeyen Sanatçı",
  "rel.list.untitled": "İsimsiz yayın",
  "rel.list.empty": "Boş",
  "rel.list.emptyTitle": "Henüz yayın yok",
  "rel.list.emptyDesc": "İlk yayınınızı oluşturun; Spotify, Apple Music ve 150+ mağazada yayınlayın.",
  "rel.list.noResultsTitle": "Filtrelere uyan yayın yok",
  "rel.list.noResultsDesc": "Farklı bir arama terimi veya durum filtresi deneyin.",
  "rel.list.clearFilters": "Filtreleri temizle",
  "rel.list.adminNote": "Ekibimizden not",
  "rel.list.releaseDate": "Yayın tarihi",
  "rel.list.created": "Oluşturuldu",
  "rel.list.inDays": "{n} gün sonra",
  "rel.list.today": "Bugün",
  "rel.list.tomorrow": "Yarın",
  "rel.list.tracks": "{n} parça",
  "rel.list.col.release": "Yayın",
  "rel.list.col.artist": "Sanatçı",
  "rel.list.col.tracks": "Parça",
  "rel.list.col.status": "Durum",
  "rel.list.col.date": "Yayın tarihi",
  "rel.list.deleteTitle": "Yayını sil",
  "rel.list.deleteConfirm": "“{name}” silinsin mi?",
  "rel.list.cannotUndo": "Bu işlem geri alınamaz.",
  "rel.list.deleteSuccess": "Yayın silindi",
  "rel.list.deleteFailed": "Silme işlemi başarısız oldu",
  "rel.list.fetchFailed": "Yayınlarınız yüklenemedi",
  "rel.list.count": "{n} yayın",

  "rel.detail.back": "Yayınlara dön",
  "rel.detail.loadFailed": "Bu yayın yüklenemedi",
  "rel.detail.timeline": "Durum zaman çizelgesi",
  "rel.detail.step.created": "Oluşturuldu",
  "rel.detail.step.submitted": "Gönderildi",
  "rel.detail.step.reviewed": "İncelendi",
  "rel.detail.step.live": "Yayında",
  "rel.detail.pending": "Bekliyor",
  "rel.detail.feedbackEdits": "Ekibimiz düzenleme talep etti",
  "rel.detail.feedbackRejected": "Yayınınız reddedildi",
  "rel.detail.feedbackTakenDown": "Yayınınız kaldırıldı",
  "rel.detail.fixNow": "Şimdi düzelt",
  "rel.detail.tracks": "Parçalar",
  "rel.detail.noTracks": "Henüz parça eklenmedi",
  "rel.detail.play": "Önizlemeyi oynat",
  "rel.detail.pause": "Duraklat",
  "rel.detail.noAudio": "Ses yok",
  "rel.detail.quickActions": "Hızlı işlemler",
  "rel.detail.smartLink": "Smart Link",
  "rel.detail.preSave": "Pre-Save",
  "rel.detail.edit": "Düzenle",
  "rel.detail.listenOn": "Dinle",
  "rel.detail.info": "Yayın bilgileri",
  "rel.detail.releaseDate": "Yayın tarihi",
  "rel.detail.genre": "Tür",
  "rel.detail.subGenre": "Alt tür",
  "rel.detail.type": "Tür (yayın)",
  "rel.detail.label": "Plak şirketi",
  "rel.detail.version": "Versiyon",
  "rel.detail.language": "Dil",
  "rel.detail.publisher": "Yayıncı",
  "rel.detail.stores": "Mağazalar ({n})",
  "rel.detail.explicit": "Müstehcen",
  "rel.detail.instrumental": "Enstrümantal",
  "rel.detail.history": "Geçmiş",
  "rel.detail.songwriters": "Söz yazarları",
  "rel.detail.featuring": "feat.",
  "rel.detail.lyrics": "Sözler",
  "rel.detail.takedownRequested": "Kaldırma talep edildi",
  "rel.detail.liveIn": "{n} gün sonra yayında",
  "rel.detail.liveToday": "Bugün yayında",
  "rel.edit.notEditable": "Bu yayın artık düzenlenemez. Yalnızca taslaklar ve düzenleme istenen yayınlar değiştirilebilir.",
};

const es = {
  "rel.autosave.unsaved": "Cambios sin guardar",
  "rel.autosave.error": "No se pudo guardar",
  "rel.autosave.savedAt": "Guardado {time}",
  "rel.autosave.idle": "Los cambios se guardan automáticamente",
  "rel.drafts.title": "Mis borradores",
  "rel.drafts.empty": "Aún no hay borradores",
  "rel.drafts.emptyDesc": "Los borradores se guardan automáticamente mientras completas el asistente.",
  "rel.drafts.close": "Cerrar",
  "rel.drafts.lastSaved": "Guardado {date}",
  "rel.drafts.resumed": "Borrador restaurado — continúa donde lo dejaste",
  "rel.drafts.saved": "Borrador guardado",
  "rel.drafts.saveFailed": "No se pudo guardar el borrador",
  "rel.drafts.needsMore": "Añade un título o sube un archivo antes de guardar el borrador",
  "rel.drafts.needsEdits": "Requiere cambios",

  "rel.wizard.confirmRequired": "Confirma todos los elementos obligatorios para continuar.",
  "rel.wizard.fillRequired": "Completa todos los campos obligatorios para habilitar el envío",
  "rel.wizard.untitledTrack": "Pista sin título",
  "rel.wizard.previous": "Anterior",
  "rel.wizard.albumSubmitted": "¡Álbum enviado con éxito!",
  "rel.wizard.albumSubmitFailed": "No se pudo enviar el álbum",
  "rel.wizard.split.title": "Reparto de ingresos",
  "rel.wizard.split.desc": "Comparte ingresos con colaboradores (compositores, productores, artistas invitados)",
  "rel.wizard.split.yourShare": "Tu parte:",
  "rel.wizard.split.edit": "Editar colaboradores ({n})",
  "rel.wizard.split.add": "Añadir colaboradores al reparto",
  "rel.wizard.split.explanation": "Los colaboradores recibirán una invitación por correo para aceptar su parte. Los ingresos se distribuirán automáticamente cuando acepten.",

  "rel.preview.title": "Vista previa en tiendas",
  "rel.preview.subtitle": "Vista previa en vivo mientras escribes",
  "rel.preview.open": "Vista previa",
  "rel.preview.close": "Cerrar vista previa",
  "rel.preview.single": "Sencillo",
  "rel.preview.album": "Álbum",
  "rel.preview.ep": "EP",
  "rel.preview.untitled": "Lanzamiento sin título",
  "rel.preview.untitledTrack": "Pista sin título",
  "rel.preview.artistPlaceholder": "Nombre del artista",
  "rel.preview.songs": "{n} canciones",
  "rel.preview.song": "1 canción",
  "rel.preview.dateTbd": "Fecha de lanzamiento sin definir",
  "rel.preview.disclaimer": "Vista estilizada — el aspecto final lo decide cada tienda.",
  "rel.preview.noCover": "Aún sin portada",
  "rel.preview.play": "Reproducir",
  "rel.preview.save": "Guardar",
  "rel.preview.more": "Más",

  "rel.qc.title": "Control de calidad",
  "rel.qc.score": "Calidad del lanzamiento {score}%",
  "rel.qc.subtitle": "Revisamos tu lanzamiento según las normas de las tiendas antes de enviarlo.",
  "rel.qc.refresh": "Volver a comprobar",
  "rel.qc.fix": "Corregir",
  "rel.qc.summary": "{p} correctos · {w} avisos · {f} problemas",
  "rel.qc.nonBlocking": "Los avisos no bloquean el envío, pero corregirlos reduce el riesgo de rechazo.",
  "rel.qc.grade.great": "Listo para tiendas",
  "rel.qc.grade.good": "Casi listo",
  "rel.qc.grade.poor": "Requiere atención",
  "rel.qc.group.artwork": "Portada",
  "rel.qc.group.audio": "Audio",
  "rel.qc.group.metadata": "Metadatos",
  "rel.qc.group.schedule": "Calendario",
  "rel.qc.cover.missing": "Falta la portada",
  "rel.qc.cover.checking": "Comprobando la portada…",
  "rel.qc.cover.ok": "Portada {w}×{h} {fmt}",
  "rel.qc.cover.small": "La portada mide {w}×{h}px — las tiendas exigen al menos 3000×3000px",
  "rel.qc.cover.notSquare": "La portada debe ser cuadrada (ahora {w}×{h}px)",
  "rel.qc.cover.format": "Formato {fmt} — usa JPG o PNG",
  "rel.qc.cover.unreadable": "No se pudo leer la portada",
  "rel.qc.audio.missing": "Falta el audio de “{track}”",
  "rel.qc.audio.format": "“{track}”: {fmt} — sube WAV o FLAC",
  "rel.qc.audio.sampleRate": "“{track}”: {sr} kHz — usa 44.1 kHz o más",
  "rel.qc.audio.bitDepth": "“{track}”: {bd} bits — se recomiendan 16 o 24 bits",
  "rel.qc.audio.short": "“{track}” es muy corta ({dur}) — algunas tiendas exigen 30 s+",
  "rel.qc.audio.long": "“{track}” es muy larga ({dur}) — revisa el archivo",
  "rel.qc.audio.ok": "“{track}”: {details}",
  "rel.qc.audio.pending": "“{track}”: {fmt} subido — los detalles técnicos aparecen al guardar el borrador",
  "rel.qc.title.missing": "Falta el título",
  "rel.qc.title.allCaps": "Evita TODO EN MAYÚSCULAS en “{title}”",
  "rel.qc.title.emoji": "Quita los emojis de “{title}”",
  "rel.qc.title.feat": "No pongas “feat.” en “{title}” — usa el campo de artistas invitados",
  "rel.qc.title.casing": "Revisa las mayúsculas de “{title}”",
  "rel.qc.title.spaces": "Quita los espacios extra de “{title}”",
  "rel.qc.title.ok": "El formato del título es correcto",
  "rel.qc.artist.missing": "Añade un artista principal",
  "rel.qc.artist.ok": "Artista principal definido",
  "rel.qc.explicit.missing": "Indicador de contenido explícito sin definir{track}",
  "rel.qc.explicit.ok": "Indicador de contenido explícito definido",
  "rel.qc.genre.missing": "Selecciona un género principal",
  "rel.qc.genre.ok": "Género definido",
  "rel.qc.credits.missing": "Añade al menos un crédito de compositor{track}",
  "rel.qc.credits.ok": "Créditos de compositor añadidos",
  "rel.qc.isrc.invalid": "ISRC no válido “{isrc}” (formato CC-XXX-YY-NNNNN)",
  "rel.qc.isrc.ok": "Formato ISRC válido",
  "rel.qc.date.missing": "Elige una fecha de lanzamiento",
  "rel.qc.date.past": "La fecha de lanzamiento ya pasó",
  "rel.qc.date.soon": "Faltan {n} días — se recomiendan 14+ días para pitching en playlists",
  "rel.qc.date.ok": "Lanzamiento {date} (en {n} días)",
  "rel.qc.label.missing": "Sin sello / línea © — se usará tu nombre artístico",
  "rel.qc.label.ok": "Sello / línea © definido",

  "rel.success.title": "¡Tu lanzamiento está en camino!",
  "rel.success.subtitle": "“{title}” se envió a revisión.",
  "rel.success.reviewTime": "Tiempo de revisión",
  "rel.success.reviewTimeValue": "1–3 días hábiles",
  "rel.success.expectedLive": "Fecha de publicación prevista",
  "rel.success.dateTbd": "Sin definir",
  "rel.success.next": "Próximos pasos",
  "rel.success.smartLink": "Crear Smart Link",
  "rel.success.smartLinkDesc": "Un enlace a todas las tiendas — ideal para tu bio.",
  "rel.success.preSave": "Iniciar campaña Pre-Save",
  "rel.success.preSaveDesc": "Consigue guardados antes del lanzamiento para impulsar el algoritmo.",
  "rel.success.view": "Ver lanzamiento",
  "rel.success.viewDesc": "Sigue el estado de revisión y los detalles.",
  "rel.success.dashboard": "Volver al panel",
  "rel.success.dashboardDesc": "Consulta tus estadísticas e ingresos.",

  "rel.status.draft": "Borrador",
  "rel.status.submitted": "Enviado",
  "rel.status.in_review": "En revisión",
  "rel.status.needs_edits": "Requiere cambios",
  "rel.status.approved": "Aprobado",
  "rel.status.scheduled": "Programado",
  "rel.status.live": "Publicado",
  "rel.status.rejected": "Rechazado",
  "rel.status.taken_down": "Retirado",

  "rel.list.title": "Mis lanzamientos",
  "rel.list.subtitle": "Gestiona todos tus lanzamientos y sigue su estado.",
  "rel.list.new": "Nuevo lanzamiento",
  "rel.list.search": "Buscar lanzamientos…",
  "rel.list.filter": "Estado",
  "rel.list.all": "Todos",
  "rel.list.sort": "Ordenar",
  "rel.list.sort.newest": "Más recientes",
  "rel.list.sort.oldest": "Más antiguos",
  "rel.list.sort.releaseDate": "Fecha de lanzamiento",
  "rel.list.sort.az": "Nombre (A–Z)",
  "rel.list.sort.za": "Nombre (Z–A)",
  "rel.list.view.grid": "Vista de cuadrícula",
  "rel.list.view.list": "Vista de lista",
  "rel.list.view.kanban": "Vista de tablero",
  "rel.list.viewAction": "Ver",
  "rel.list.edit": "Editar",
  "rel.list.fixNow": "Corregir ahora",
  "rel.list.delete": "Eliminar",
  "rel.list.cancel": "Cancelar",
  "rel.list.actions": "Acciones",
  "rel.list.unknownArtist": "Artista desconocido",
  "rel.list.untitled": "Lanzamiento sin título",
  "rel.list.empty": "Vacío",
  "rel.list.emptyTitle": "Aún no hay lanzamientos",
  "rel.list.emptyDesc": "Crea tu primer lanzamiento y publícalo en Spotify, Apple Music y más de 150 tiendas.",
  "rel.list.noResultsTitle": "Ningún lanzamiento coincide con los filtros",
  "rel.list.noResultsDesc": "Prueba otro término de búsqueda o filtro de estado.",
  "rel.list.clearFilters": "Limpiar filtros",
  "rel.list.adminNote": "Nota de nuestro equipo",
  "rel.list.releaseDate": "Fecha de lanzamiento",
  "rel.list.created": "Creado",
  "rel.list.inDays": "en {n} días",
  "rel.list.today": "Hoy",
  "rel.list.tomorrow": "Mañana",
  "rel.list.tracks": "{n} pistas",
  "rel.list.col.release": "Lanzamiento",
  "rel.list.col.artist": "Artista",
  "rel.list.col.tracks": "Pistas",
  "rel.list.col.status": "Estado",
  "rel.list.col.date": "Fecha de lanzamiento",
  "rel.list.deleteTitle": "Eliminar lanzamiento",
  "rel.list.deleteConfirm": "¿Eliminar “{name}”?",
  "rel.list.cannotUndo": "Esta acción no se puede deshacer.",
  "rel.list.deleteSuccess": "Lanzamiento eliminado",
  "rel.list.deleteFailed": "No se pudo eliminar",
  "rel.list.fetchFailed": "No se pudieron cargar tus lanzamientos",
  "rel.list.count": "{n} lanzamientos",

  "rel.detail.back": "Volver a lanzamientos",
  "rel.detail.loadFailed": "No se pudo cargar este lanzamiento",
  "rel.detail.timeline": "Cronología del estado",
  "rel.detail.step.created": "Creado",
  "rel.detail.step.submitted": "Enviado",
  "rel.detail.step.reviewed": "Revisado",
  "rel.detail.step.live": "Publicado",
  "rel.detail.pending": "Pendiente",
  "rel.detail.feedbackEdits": "Nuestro equipo solicitó cambios",
  "rel.detail.feedbackRejected": "Tu lanzamiento fue rechazado",
  "rel.detail.feedbackTakenDown": "Tu lanzamiento fue retirado",
  "rel.detail.fixNow": "Corregir ahora",
  "rel.detail.tracks": "Pistas",
  "rel.detail.noTracks": "Aún no hay pistas",
  "rel.detail.play": "Reproducir vista previa",
  "rel.detail.pause": "Pausar",
  "rel.detail.noAudio": "Sin audio",
  "rel.detail.quickActions": "Acciones rápidas",
  "rel.detail.smartLink": "Smart Link",
  "rel.detail.preSave": "Pre-Save",
  "rel.detail.edit": "Editar",
  "rel.detail.listenOn": "Escuchar en",
  "rel.detail.info": "Información del lanzamiento",
  "rel.detail.releaseDate": "Fecha de lanzamiento",
  "rel.detail.genre": "Género",
  "rel.detail.subGenre": "Subgénero",
  "rel.detail.type": "Tipo",
  "rel.detail.label": "Sello",
  "rel.detail.version": "Versión",
  "rel.detail.language": "Idioma",
  "rel.detail.publisher": "Editorial",
  "rel.detail.stores": "Tiendas ({n})",
  "rel.detail.explicit": "Explícito",
  "rel.detail.instrumental": "Instrumental",
  "rel.detail.history": "Historial",
  "rel.detail.songwriters": "Compositores",
  "rel.detail.featuring": "feat.",
  "rel.detail.lyrics": "Letra",
  "rel.detail.takedownRequested": "Retirada solicitada",
  "rel.detail.liveIn": "Se publica en {n} días",
  "rel.detail.liveToday": "Se publica hoy",
  "rel.edit.notEditable": "Este lanzamiento ya no se puede editar. Solo se pueden modificar borradores y lanzamientos con cambios solicitados.",
};

const release = { en, tr, es };
export default release;
